import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-update-nhs-modal',
  templateUrl: './update-nhs-modal.component.html',
  styleUrls: ['./update-nhs-modal.component.scss'],
})
export class UpdateNhsModalComponent implements OnInit {

  @Input() header:string;
  @Input() message:string;
  @Input() value:any;
  @Input() mode:string;
  @Input() isClubSpecific:any;
  @Input() selClubMembership:any;
  @Input() slot:any;
  actionItem:any[]=[
    {value:'handicap',header:'Change Handicap'},
    {value:'teeBox',header:'Change Tee Box'},
    {value:'removePlayer',header:'Remove Player'}
  ]

  upadteNHSValue:any;

  constructor(
    private mdlCtrl:ModalController,
    private router:Router
  ) {}

  ngOnInit() {
    if(this.value){
      this.upadteNHSValue = this.value
    }
    if(this.isClubSpecific){
      this.upadteNHSValue = this.selClubMembership.club.clubId.toString() || ''
    }
    if(this.slot===1){
      this.actionItem.splice(2,1)
    }
  }

  /*
   * Method for the close
   */
  close(){
    this.mdlCtrl.dismiss();
  }

  /*
   * Method for the confirm nhs value
   */
  confirm(){
    this.mdlCtrl.dismiss(this.upadteNHSValue);
  }

  /*
   * Method for the select action menu
   */
  actionItemSelect(data:string){
    this.mdlCtrl.dismiss(data);
  }

}
